import { Countries } from './rest-countries-vendor/countries';

/**
 * @RestCountries
 * Entry file for all RestCountries API call
 */
export class RestCountries extends Countries {
  constructor() {
    super();
  }
}
